// AdminRoute.jsx
// Route guard that allows access only to users with role = 'admin'.
// Non-authenticated users → /login
// Authenticated non-admins → / (with an access-denied message in state)

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children }) {
  const { currentUser, isAdmin, userRole } = useAuth();
  const location = useLocation();

  // Not logged in at all → send to login
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Logged in but role is still loading (null means not yet fetched)
  // Show a brief loading indicator to avoid a flash redirect
  if (userRole === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600" />
      </div>
    );
  }

  // Logged in but not an admin → redirect to home with access-denied flag
  if (!isAdmin) {
    return <Navigate to="/" state={{ accessDenied: true }} replace />;
  }

  return children;
}
